import { Box, Container, HStack, Text, Flex, Link as LinkR } from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, Link } from "@tanstack/react-router"

import TitleBar from "../../components/UI/TitleBar"
import useAuth from "../../hooks/useAuth"
import { useEffect, useState } from "react"
import { getModuleVersions } from "../../utils"

export const Route = createFileRoute("/_layout/")({
  component: Dashboard,
})


function Dashboard() {
  const { user: currentUser } = useAuth()

  const [displayedData, setDisplayedData] = useState<any[string]>()

  const { data: versions } = useQuery({...getModuleVersions()})

  useEffect(() => {
    if (versions) {
      setDisplayedData(versions)
    }
  }, [versions])

  return (
    <Container maxW="full">
      <TitleBar title="Dashboard" />
      <Box pt={12} m={4}>
        <Text fontSize="2xl">
          Sali, {currentUser?.firstname || currentUser?.email} 👋🏼
        </Text>
        <Text>Willkommen im Redaktionssystem der Wochen-Zeitung!</Text>
        <Text fontSize="xs" position="fixed" bottom={4} right={10}>
          Bei Problemen oder Fragen, melde dich unter folgender E-Mail: <LinkR href="mailto:informatik@wochen-zeitung.ch" color="main">informatik@wochen-zeitung.ch</LinkR>
        </Text>
        <Box mt={10}>
          {displayedData != undefined &&
            Object.keys(displayedData)?.map((key, index) => (
              <HStack key={index}>
              <Text mr={5}>{key}</Text>
              <Text>{displayedData[key]}</Text>
            </HStack>
          ))}
        </Box>
      </Box>

      <Flex fontSize={14} spaceX={8} p={3} pos="fixed" bottom={0}>
        <Link to="/datenschutz">Datenschutz</Link>
        <Link to="/impressum">Impressum</Link>
      </Flex>
    </Container>
  )
}
